import React, { Component } from 'react';
import { CardElement, injectStripe } from 'react-stripe-elements/dist/react-stripe-elements';
import './CheckoutForm.css'
import InputWithClearButton from '../InputWithClearButton';
import { alertNotValid, showMessage } from '../alerts'
import Loader from '../Loader'
import MultiDropDown from '../MultiDropDown/MultiDropDown'
import { Service } from '../ApiService';
import RadioButton from '../RadioButton'

class CheckoutForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            complete: false,
            orderId: props.orderId,
            name: '',
            address: {},
            email: '',
            cardNumber: '',
            loading: false,
            cards: [],
            cardId: null,
            useExistingCard: false
        };
        this.submit = this.submit.bind(this);
        this.cardDropDownRef = null;
    }

    componentDidMount() {
        this.setState({ loading: true });
        Service.GetPaymentUserData(this.state.orderId).then(data => {
            this.setState({
                name: data.name,
                address: data.address,
                email: data.email,
                cards: data.cards
            }, () => this.setState({ loading: false }));
        });
    }

    updateAddressProperty(property, value) {
        let address = { ...this.state.address };
        address[property] = value;
        this.setState({ address });
    }


    stateNameAndAbbrRender(element, textProperty) {
        return <span className='text-transform-none'>
            {element.name + ', ' + element.abbreviation}
        </span>
    }

    submit = async (event) => {
        event.preventDefault();

        this.setState({ loading: true }, async () => {

            if (this.state.loading) {
                var tokenId = null;
                if (!this.state.useExistingCard) {
                    //let { token } = await this.props.stripe.createToken({ name: this.state.name, email: this.state.email });
                    let algo = await this.props.stripe.createToken({ name: this.state.name, email: this.state.email, zip: this.state.address.zip });

                    if (!algo.token) {
                        this.headerText = 'Failure';
                        this.dialogText = "Unable to process payment";
                        this.dialogContent = <h4>{algo.error.message}</h4>
                        this.mode = 'error'
                        this.setState({ loading: false, showMessage: true });
                        return false;
                        //return Promise.reject(new Error(algo.error.message));
                    }
                    else 
                        tokenId = algo.token.id;

                }
                else {
                    tokenId = this.state.cardId;
                    if (!tokenId) {
                        this.setState({ loading: false });
                        return Promise.reject();
                    }
                }
                let response = await fetch("/api/Pay/Submit", {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    method: "POST",
                    //headers: { "Content-Type": "text/plain" },
                    body: JSON.stringify({
                        token: tokenId,
                        orderId: this.state.orderId,
                        name: this.state.name,
                        email: this.state.email,
                        line1: this.state.address.line1,
                        city: this.state.address.city,
                        state: this.state.address.state,
                        zip: this.state.address.zip,
                        existingCard: this.state.useExistingCard
                    })
                });

                response.json().then(res => {
                    if (res.success) {
                        window.open(res.receiptUrl, "_blank");
                        this.setState({ loading: false, complete: true });

                        {/*<h2>Payment Successful!</h2>
                    <a href={res.receiptUrl}>View Receipt</a>
                    <Link to="/">Home</Link>
                </div >*/}
                    }
                    else {
                        this.headerText = 'Failure';
                        this.dialogText = "Unable to process payment";
                        this.dialogContent = <h4>{res.message}</h4>
                        this.mode = 'error'
                        this.setState({ loading: false, showMessage: true });
                        return Promise.reject(new Error(res.message));
                    }
                })
                    .catch(err => {
                        console.log(err);
                        this.setState({ loading: false });
                    });
            }
        });

        //if (response.ok) this.setState({ complete: true });
    }

    textPropertyRender(element, textProperty) {
        return <div style={{ display: 'flex' }}>
            <span className='ml-1 small-bold'>{element.brand + ' : ' + element.last4}</span>
            <span className="ml-1 small-bold">{'Expiration: ' + element.expiration}</span>
        </div>
    }

    setBrandIcon = (brand, index) => {
        const cardBrandToPfClass = {
            'visa': 'pf-visa',
            'mastercard': 'pf-mastercard',
            'amex': 'pf-american-express',
            'discover': 'pf-discover',
            'diners': 'pf-diners',
            'jcb': 'pf-jcb',
            'unknown': 'pf-credit-card',
        }

        //var brandIconElement = document.getElementById('brand-icon-' + index);
        var pfClass = 'pf-credit-card';
        if (brand in cardBrandToPfClass) {
            pfClass = cardBrandToPfClass[brand];
        }
        //for (var i = brandIconElement.classList.length - 1; i >= 0; i--) {
        //    brandIconElement.classList.remove(brandIconElement.classList[i]);
        //}
        //brandIconElement.classList.add('pf');
        //brandIconElement.classList.add(pfClass);

        return pfClass;
    }


    render = () => {
        const stateList = [{ "name": "Alabama", "abbreviation": "AL" }, { "name": "Alaska", "abbreviation": "AK" }, { "name": "Arizona", "abbreviation": "AZ" }, { "name": "Arkansas", "abbreviation": "AR" }, { "name": "California", "abbreviation": "CA" }, { "name": "Colorado", "abbreviation": "CO" }, { "name": "Connecticut", "abbreviation": "CT" }, { "name": "Delaware", "abbreviation": "DE" }, { "name": "District of Columbia", "abbreviation": "DC" }, { "name": "Florida", "abbreviation": "FL" }, { "name": "Georgia", "abbreviation": "GA" }, { "name": "Hawaii", "abbreviation": "HI" }, { "name": "Idaho", "abbreviation": "ID" }, { "name": "Illinois", "abbreviation": "IL" }, { "name": "Indiana", "abbreviation": "IN" }, { "name": "Iowa", "abbreviation": "IA" }, { "name": "Kansas", "abbreviation": "KS" }, { "name": "Kentucky", "abbreviation": "KY" }, { "name": "Louisiana", "abbreviation": "LA" }, { "name": "Maine", "abbreviation": "ME" }, { "name": "Maryland", "abbreviation": "MD" }, { "name": "Massachusetts", "abbreviation": "MA" }, { "name": "Michigan", "abbreviation": "MI" }, { "name": "Minnesota", "abbreviation": "MN" }, { "name": "Mississippi", "abbreviation": "MS" }, { "name": "Missouri", "abbreviation": "MO" }, { "name": "Montana", "abbreviation": "MT" }, { "name": "Nebraska", "abbreviation": "NE" }, { "name": "Nevada", "abbreviation": "NV" }, { "name": "New Hampshire", "abbreviation": "NH" }, { "name": "New Jersey", "abbreviation": "NJ" }, { "name": "New Mexico", "abbreviation": "NM" }, { "name": "New York", "abbreviation": "NY" }, { "name": "North Carolina", "abbreviation": "NC" }, { "name": "North Dakota", "abbreviation": "ND" }, { "name": "Ohio", "abbreviation": "OH" }, { "name": "Oklahoma", "abbreviation": "OK" }, { "name": "Oregon", "abbreviation": "OR" }, { "name": "Pennsylvania", "abbreviation": "PA" }, { "name": "Rhode Island", "abbreviation": "RI" }, { "name": "South Carolina", "abbreviation": "SC" }, { "name": "South Dakota", "abbreviation": "SD" }, { "name": "Tennessee", "abbreviation": "TN" }, { "name": "Texas", "abbreviation": "TX" }, { "name": "Utah", "abbreviation": "UT" }, { "name": "Vermont", "abbreviation": "VT" }, { "name": "Virginia", "abbreviation": "VA" }, { "name": "Washington", "abbreviation": "WA" }, { "name": "West Virginia", "abbreviation": "WV" }, { "name": "Wisconsin", "abbreviation": "WI" }, { "name": "Wyoming", "abbreviation": "WY" }];

        if (this.state.complete) return <h1>Purchase Complete</h1>;

        return (
            <div className="Checkout">
                <h4 className='mb-1'>Please provide payment information</h4>
                <form>
                    <ul className='input-fields first-child-text-145 pl-1 pr-1'>

                        <li>
                            <p>Card holder user name:</p>
                            <InputWithClearButton
                                className='StripeElement'
                                type='text'
                                placeholder='Please enter name as stated on card'
                                value={this.state.name}
                                onChange={e => {
                                    this.setState({ name: e.target.value });
                                }}
                                onClearValue={() => {
                                    this.setState({ name: '' });
                                }}
                            />
                        </li>
                        <li>
                            <p>Email:</p>
                            <InputWithClearButton
                                className='StripeElement'
                                type='email'
                                placeholder='Please enter email'
                                value={this.state.email}
                                onChange={e => {
                                    this.setState({ email: e.target.value });
                                }}
                                onClearValue={() => {
                                    this.setState({ email: '' });
                                }}
                            />
                        </li>

                        <li className='input-wrapper'>
                            <p>Billing Address:</p>
                            <input
                                type='text'
                                placeholder='Street Address'
                                value={this.state.address.line1}
                                onChange={e => this.updateAddressProperty("line1", e.target.value)}
                            />
                        </li>
                        <li>
                            <span className='empty'></span>
                            <ul className='input-fields flex-nowrap break-at-560 line-of-inputs-wrapper'>
                                <li
                                    className='input-wrapper'
                                    style={{ "flex": "1 1 auto" }}
                                >
                                        <input
                                            className='small-bold'
                                        type='text'
                                        placeholder='City'
                                        value={this.state.address.city}
                                        onChange={e => this.updateAddressProperty("city", e.target.value)}
                                        />
                                </li>
                                <li className='input-wrapper' style={{ "flex": "1 0 150px" }}>
                                    <MultiDropDown
                                        ref={el => this.cardDropDownRef = el}
                                        list={stateList}
                                        multiSelect={false}
                                        keyProperty='abbreviation'
                                        textProperty='abbreviation'
                                        defaultValue={this.state.address.state}
                                        placeholder="State"
                                        textPropertyRender={(element, textProperty) => this.stateNameAndAbbrRender(element, textProperty)}
                                        onDropDownValueChange={value => this.updateAddressProperty("state", value)}
                                        search={this.filterList}
                                        searchParams={['abbreviation', 'name']}
                                    //searchMinCharacterCount = {5}
                                    />
                                </li>
                                <li className='input-wrapper' style={{ "flex": "0 0 100px" }}>
                                    <input
                                        type='text'
                                        placeholder='Zip'
                                        maxLength={5}
                                        value={this.state.address.zip}
                                        onChange={e => this.updateAddressProperty("zip", e.target.value)}
                                    />
                                </li>
                            </ul>
                        </li>
                        {this.state.cards && this.state.cards.length > 0 &&

                            <li>
                                <RadioButton
                                    radioGroupElement={this.state.useExistingCard}
                                    radioButtonValue={true}
                                    onClick={(value) => {
                                        this.setState({ useExistingCard: true });
                                    }}
                                    labelClassName="checkbox-text"
                                    labelText='Select a card:'
                                />
                                <MultiDropDown
                                    list={this.state.cards}
                                    keyProperty='id'
                                    textProperty='description'
                                    multiSelect={false}
                                    defaultValue={this.state.cardId}
                                    placeholder="Select existing card"
                                    //customHeightCoeff={3}
                                    textPropertyRender={(element, textProperty) => this.textPropertyRender(element, textProperty)}
                                    onDropDownValueChange={value => {
                                        this.emptyType = false;
                                        this.setState({ cardId: value })
                                    }}
                                />
                            </li>
                        }
                        <li>
                            {this.state.cards && this.state.cards.length > 0 ? <RadioButton
                                radioGroupElement={this.state.useExistingCard}
                                radioButtonValue={false}
                                onClick={(value) => {
                                    this.setState({ useExistingCard: false });
                                }}
                                labelClassName="checkbox-text"
                                labelText='New card'
                            /> : <span/>
                            }
                            <CardElement />
                        </li>

                    </ul>

                    <button className="payButton" onClick={this.submit}>Pay</button>
                </form>

                {this.state.loading && <Loader />}
                {this.state.showMessage && showMessage(this.headerText, this.dialogText, this.dialogContent, this.mode, () => this.setState({ showMessage: false }))}
            </div>
        );
    }
}

export default injectStripe(CheckoutForm);


{/*
            <div className="checkout">
                <p>Would you like to complete the purchase?</p>


                <CardElement />
                <button className='medium-static-button static-button default-button' onClick={this.submit}>Purchase</button>
            </div>
            */}


// WEBPACK FOOTER //
// ./src/components/Payment/CheckoutForm.jsx